var map = {
	"./BNI.png": 3981,
	"./BRI.png": 3545,
	"./GOPAY.png": 8340,
	"./MANDIRI.png": 1470,
	"./OVO.png": 1050,
	"./QRIS.png": 9103,
	"./SHOPEE.png": 3488,
	"./bca.png": 8314,
	"./ceklis.png": 2083,
	"./femaleDoctor.png": 3579,
	"./man.png": 8028,
	"./payment.png": 9198,
	"./young.png": 6456
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9513;